var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-contact-bd"},[_c('div',{staticClass:"partner-contact-wrap"},[_c('div',{staticClass:"table-bd"},[_c('custom-table',{attrs:{"data":_vm.contactList,"loading":_vm.isLoading,"column":_vm.tableColumn},on:{"filter":_vm.filterChange,"sort":_vm.sortChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }